/**
 * http请求预处理，包括request和response拦截器
 * 在登录的情况下，对所有的request请求添加用户认证token
 * 对所有的返回信息进行拦截，发现401错误（未登录或登录验证异常），跳转到登录页面
 */

import axios from 'axios'
import apis from '../services/apis.js'
import router from '../main.js'
import Qs from 'qs'
import Auth from './auth.js'
import { Message } from 'element-ui' 
import Vue from 'vue'
import { runInNewContext } from 'vm';
//导入进度条插件
import NProgress from 'nprogress'
//导入进度条样式
import 'nprogress/nprogress.css'

//loading框设置局部刷新，且所有请求完成后关闭loading框
let loading;
function startLoading() {
    loading = Vue.prototype.$loading({
        lock: true,
        text: "Loading...",
        target: document.querySelector('.loading-area') //设置加载动画区域
    });
    NProgress.start();
}

function endLoading() {
    loading.close();
    NProgress.done();

}

//声明一个对象用于存储请求个数
let needLoadingRequestCount = 0;
function showFullScreenLoading() {
    if (needLoadingRequestCount === 0){
        startLoading();
    }
    needLoadingRequestCount++;
}

function tryHideFullScreenLoading() {
    if (needLoadingRequestCount <= 0){
        return;
    }
    needLoadingRequestCount--;
    if (needLoadingRequestCount === 0){
        endLoading();
    }
}
// axios 配置
axios.defaults.timeout = 6000000;
axios.defaults.baseURL = apis.base;
axios.defaults.headers.post['Content-Type'] = 'application/json;charset=UTF-8';
// axios.defaults.headers = {
//     'Content-Type': 'application/json'
// } 
axios.defaults.transformRequest = function (data) {
    // data = Qs.stringify(data);
    // console.log(data)
    return data;
};
// console.log(axios)



// http request 拦截器
axios.interceptors.request.use(
    config => {
        
        // console.log(config);
        // config.withCredentials = true;
        // config.headers = {
        //     // 'access-token': 'token',
        //     'Content-Type': 'application/x-www-form-urlencoded'
        // }
        //设置拦截登录超时
        // router.replace({
        //     name: 'login',
        //     params: {redirect: '/login'}
        // })
        // if (Auth.authenticated()) {
        //     console.log(1111)
        //     var token = Auth.getToken();
        //     config.headers.common["Authorization"] = token; 
        //     console.log(token)
        // }
        showFullScreenLoading();
        return config;
    },
    err => {
        // console.log(err)
        tryHideFullScreenLoading();
        Message.error({ message: '请求超时' });
        return Promise.reject(err);
    }
);

axios.interceptors.response.use(
    response => {
        // console.log(response)
        tryHideFullScreenLoading();
        return response;
    },
    error => {
        Vue.prototype.$message('返回错误，请稍后再试！');
        // console.log(error)
        tryHideFullScreenLoading();
        if (error.response) {
            switch (error.response.status) {
                case 401:
                    // 401 清除token信息并跳转到登录页面
                    Auth.logout();
                    router.replace({
                        name: 'login',
                        params: { redirect: router.currentRoute.fullPath}
                    })
            }
        }
        return Promise.reject(error)
    }
);
export default axios;



// WEBPACK FOOTER //
// ./src/services/http.js